import React, { Fragment, useEffect } from "react";
import RootPublicLayout from "./RootPublicLayout";
import RootProfileNavBar2 from "../../components/navegation/RootProfileNavBar2";
import { useSelector, useDispatch } from "react-redux";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { fetchUserProfile } from "../../store/redux_auth/authSlice";
import SessionExpiredModal from "../../components/ui/popup/SessionExpiredModal";
import NavbarGhost from "../../components/ui/loading/skeletons/global/NavbarGhost";

function RootNavBar() {
  const dispatch = useDispatch();
  const { isAuthenticated, isLoading, user } = useSelector(
    (state) => state.auth,
  );

  // Initialize Google Analytics tracking for ALL routes
  useGoogleAnalytics();

  // On app initialization, check if Knox cookie is valid by fetching user profile
  // This restores authentication state after page refresh
  useEffect(() => {
    if (!isAuthenticated && !user && isLoading) {
      dispatch(fetchUserProfile());
    }
  }, []); // Only run once on mount

  if (isLoading) {
    return <NavbarGhost />;
  }

  return (
    <Fragment>
      {!isAuthenticated && (
        <>
          <RootPublicLayout />
        </>
      )}
      {isAuthenticated && (
        <>
          {/* Now it only exists when they ARE logged in */}
          <SessionExpiredModal />
          <RootProfileNavBar2 />
        </>
      )}
    </Fragment>
  );
}

export default RootNavBar;
